import { createFileRoute } from '@tanstack/react-router';

import CalculationAddTemplatePage from '@/areas/calculations/Calculation/Templates/AddTemplatePage/CalculationAddTemplatePage';
import { canCreateCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/calculation/create')({
    staticData: { access: { permissions: canCreateCalculationTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CalculationAddTemplatePage />;
}
